<div class="account-management-result">
    <div class="container-fluid">
      <div class="bg-white p-3 mt-2">

        <div class="row ps-1 pe-1">
          <div class="col-md-2 col-sm-12 mb-1">
            <h1>
              Vet Account Management
            </h1>
          </div>

          <div class="col-md-10 col-sm-12">
            <div class="row g-3 flex justify-content-end">
              <div class="col-3">
                <app-search-box placeholder="Search..."
                                (searchChange)="filterAccounts($event)">
                </app-search-box>

              </div>
          
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-3">


            <form class="d-flex flex-column align-items-start w-100">
              <div class="mb-3 w-100">
                <label class="custom-control-label"
                       for="saleFilter">Sale</label>
                <select class="form-control custom-form-select dropdown-arrow custom-dropdown-form-select"
                        id="saleFilter"
                        [(ngModel)]="selectedSale.id"
                        name="saleFilter"
                        (change)="loadVetUsers()"
                        [ngClass]="{'custom-dropdown-small-select': selectedSale?.id === 0}">
                  <option *ngFor="let option of saleLooup" [ngValue]="option.id" [selected]="option.id === selectedSale.id">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </form>


          </div>
        </div>
        <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-lg mt-4"
             #table>
          <table mat-table
                 class="table table-hover"
                 matSort="sort" [dataSource]="dataSource"
                 infiniteScroll
                 [infiniteScrollDistance]="2"
                 [infiniteScrollThrottle]="20"
                 [infiniteScrollContainer]="table"
                 [fromRoot]="true"
                 (scrolled)="onTableScroll()">
            <!--
      <ng-container matColumnDef="checkbox">
        <th
          scope="col"
          class="checkbox-heading w-3-rem"
          mat-header-cell
          *matHeaderCellDef
        >
          <div
            class="custom-control custom-checkbox custom-checkbox-lg blank-label"
          >
            <input
              class="custom-control-input"
              type="checkbox"
              [(ngModel)]="checkedAll"
              (ngModelChange)="onChangeCheckboxes(checkedAll, 'ALL')"
              id="allCheckbox"
            />
            <label
              class="custom-control-label custom-control-label-all"
            ></label>
          </div>
        </th>
        <td
          *matCellDef="let element; let vetUserIndex = index"
          class="less-height-1-8-rem"
        >
          <div
            class="custom-control custom-checkbox custom-checkbox-lg blank-label ps-3"
          >
            <input
              class="custom-control-input"
              type="checkbox"
              [(ngModel)]="element.checkbox"
              (change)="
                onChangeCheckboxes(element.checkbox, 'SINGLE', element)
              "
              id="blankCheckbox-{{ vetUserIndex }}"
            />
            <label
              class="custom-control-label"
              for="blankCheckbox-{{ vetUserIndex }}"
            ></label>
          </div>
        </td>
      </ng-container> -->

            <ng-container matColumnDef="vetName">
              <th mat-header-cell
                  class="clinic-heading col-auto"
                  *matHeaderCellDef
                  mat-sort-header>
                Vet Name <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element" class="less-height-1-8-rem">
                {{ element.vetName }}
              </td>
            </ng-container>




            <!--  <ng-container matColumnDef="clinic">
          <th mat-header-cell
              mat-sort-header
              class="clinic-heading w-10-rem cursor-pointer"
              *matHeaderCellDef>
              Vet Name <i class="fa fa-sort ms-1"></i>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.memberName }}</td>
      </ng-container>-->

            <ng-container matColumnDef="emailAddress">
              <th mat-header-cell
                  mat-sort-header
                  class="email-address-heading  cursor-pointer col-2"
                  *matHeaderCellDef>
                Email <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.emailAddress }}
              </td>
            </ng-container>

            <ng-container matColumnDef="phoneNumber">
              <th mat-header-cell
                  mat-sort-header
                  class="phone-number-heading col-1 cursor-pointer"
                  *matHeaderCellDef>
                Phone No <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="phone-number-section">
                  <div class="phone-number">
                    {{ element.mobile }}<br *ngIf="element.mobile" />
                    {{ element.phoneNumber1 }}<br *ngIf="element.phoneNumber1" />
                    {{ element.phoneNumber2 }}<br *ngIf="element.phoneNumber2" />
                    {{
 element.contactNumber1
                    }}<br *ngIf="element.contactNumber1" />
                    {{
 element.contactNumber2
                    }}<br *ngIf="element.contactNumber2" />
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="memberName">
              <th mat-header-cell
                  mat-sort-header
                  class="address-heading col-2"
                  *matHeaderCellDef>
                Clinic <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell
                  *matCellDef="let element"
                  class="less-height-1-rem pt-2 pb-2 ">
                <div class="address-section">
                  {{ element.memberName }}<br />
                  <span class="text-gray">
                    {{ element.address }} <br />
                    {{ element.city }} {{ element.state }} {{ element.postCode }}
                    <br />
                    {{ element.countryName }}
                  </span>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="organisationID">
              <th mat-header-cell
                  mat-sort-header
                  class="org-id-heading col-auto cursor-pointer"
                  *matHeaderCellDef>
                OrgID <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.organisationID }}
              </td>
            </ng-container>



            <ng-container matColumnDef="accreditationNumber">
              <th mat-header-cell
                  mat-sort-header
                  class="accreditation-number-heading col-auto cursor-pointer"
                  *matHeaderCellDef>
                Accreditation Number <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.accreditationNumber }}
              </td>
            </ng-container>

            <ng-container matColumnDef="saleAccess">
              <th mat-header-cell
                  mat-sort-header
                  class="org-id-heading col-auto cursor-pointer"
                  *matHeaderCellDef>
                Access <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element">

                <span class="study-status-box study-status-box-{{element.accessStatusCode}}">
                  {{element.saleAccess}}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="saleName">
              <th mat-header-cell
                  mat-sort-header
                  class="status-heading col-auto cursor-pointer"
                  *matHeaderCellDef>
                Sale <i class="fa fa-sort ms-1"></i>
              </th>
              <td mat-cell *matCellDef="let element"> {{ element.saleName }}</td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell
                  class="action-heading col-1"
                  *matHeaderCellDef>
              </th>
              <td mat-cell *matCellDef="let element">
                <button type="button"
                        class="btn btn-outline-primary btn-sm mb-1"
                        (click)="ResetPassword(element)"
                        title="Reset Password">
                  <i class="fa fa-spinner fa-spin" *ngIf="element?.loading"></i>
                  <i class="fa fa-key" *ngIf="!element?.loading"></i>
                </button>
                <button type="button" *ngIf="IsSalesComapny()"
                        class="btn btn-outline-primary btn-sm ms-1 mb-1"
                        (click)="navigateToMemberAccess(element.memberId,element.memberName)"
                        title="Permissions">

                  <i class="fas fa-shield-alt"></i>
                </button>
                <button class="btn btn-outline-primary btn-sm ms-1 mb-1" *ngIf="IsSalesComapny()"
                        (click)="vetProfileDetail(element)">
                  <i class="fa fa-edit"></i>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
            <tr mat-row
                *matRowDef="
              let row;
              columns: displayedColumns$.value;
              let vetUserIndex = index
            "
                class="border-start-0 border-end-0 pointer pt-2"></tr>
          </table>

          <!--<div class="col-md-12 text-center" *ngIf="isLoader">
        Loading <i class="fa fa-spinner fa-spin"></i>
    </div>-->
        </div>
      </div>
    </div>
</div>
